import {
    Card,
    Button,
    Loading,
    BaseTable,
    ActionButton,
    Select,
    Modal,
    CommandButton,
    CancelButton,
} from "components"
import { useProfileDetail } from "../utils/useProfileDetail"
import moment from "moment"
import { useEffect, useState } from "react"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { Controller, useFieldArray, useForm } from "react-hook-form"
import { convertNumber, useApi } from "utils"
import toast from "react-hot-toast"
import { useBoqDetail } from "../utils/useBoqDetail"
import { TabSubTransaction } from "../components/TabSubTransaction"
import { useBillByProject } from "../utils/useBillByProject"
import { billTransactionSchema, BillType, FormBillBoqType, FormBillType } from "../types/BillTypes";
import { TableBillItem } from "../components/TableBillItem"
import { useBillServiceByProject } from "../utils/useBillServiceByProject"
import { BillServiceType, FormBillServiceType } from "../types/BillServiceTypes"
import { TableBillServiceItem } from "../components/TableBillServiceItem"
import { useSpendMoneyByProject } from "../utils/useSpendMoneyByProject"
import { FormSpendMoneyType, SpendMoneyType } from "../types/SpendMoneyTypes"
import { TableSpendMoneyItem } from "../components/TableSpendMoneyItem"
import { useReceivedMoneyByProject } from "../utils/useReceivedMoneyByProject"
import { useInvoiceByProject } from "../utils/useInvoiceByProject"
import { usePaymentBillByProject } from "../utils/usePaymentBillByProject"
import { PaymentBillItem } from "../types/SubTransactionTypes"
import { usePaymentInvoiceByProject } from "../utils/usePaymentInvoiceByProject"

interface TabProps{
    action?:string
    project_id?:string
    approval_view?:boolean
    data_profile?:FormStateProjectProfile
}

function parseDeleteTrxError(err: unknown): string {
    const ax = err as {
        response?: { data?: { detail?: unknown; message?: string } }
    }
    const d = ax.response?.data?.detail
    if (typeof d === "string") return d
    if (Array.isArray(d) && d[0]?.msg) return String(d[0].msg)
    if (ax.response?.data?.message) return String(ax.response.data.message)
    return "Failed to delete BOQ mapping. Please try again."
}

type ProjectTrxDeleteModalsProps = {
    showConfirm: boolean
    onCloseConfirm: () => void
    deleteLoading: boolean
    onConfirmDelete: () => void
    errorMessage: string | null
    onDismissError: () => void
}

function ProjectTrxDeleteModals({
    showConfirm,
    onCloseConfirm,
    deleteLoading,
    onConfirmDelete,
    errorMessage,
    onDismissError,
}: ProjectTrxDeleteModalsProps): JSX.Element {
    return (
        <>
            {showConfirm && (
                <Modal
                    isOpen
                    title="DELETE BOQ MAPPING"
                    closeOnOverlayClick={false}
                    closeModal={onCloseConfirm}
                    style={{ maxWidth: "520px" }}
                >
                    <Modal.Body className="!h-auto flex flex-col gap-3">
                        <div className="text-error">
                            Are you sure you want to delete this BOQ mapping data?
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="flex flex-row flex-wrap justify-end items-center gap-4">
                        <CommandButton
                            type="button"
                            actiontype="delete"
                            label="DELETE"
                            buttonColor="error"
                            permission="AT021"
                            loading={deleteLoading ? "true" : undefined}
                            disabled={deleteLoading}
                            onClick={() => void onConfirmDelete()}
                        />
                        <CancelButton onClick={onCloseConfirm} />
                    </Modal.Footer>
                </Modal>
            )}

            {errorMessage !== null && (
                <Modal
                    isOpen
                    title="DELETE FAILED"
                    closeOnOverlayClick={false}
                    closeModal={onDismissError}
                    style={{ maxWidth: "520px" }}
                >
                    <Modal.Body className="!h-auto flex flex-col gap-3">
                        <div className="text-error whitespace-pre-wrap">
                            {errorMessage}
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="flex flex-row justify-end">
                        <Button
                            type="button"
                            color="primary"
                            onClick={onDismissError}
                        >
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export function TabTransaction(props:TabProps): JSX.Element {
    const [isLoading , setLoading] = useState(true)
    const { data } = useProfileDetail(props.project_id)
    const [dataProfile, setDataProfile] = useState<FormStateProjectProfile | null>(null);
    const [dayBehind,setDayBehind ] = useState(0)
    const [weekBehind,setWeekBehind ] = useState(0)
    const [activeTab , setActiveTab]  =  useState('bill')

    useEffect(() => {
        if (isLoading && ((!data || data.length === 0))) return;

        setDataProfile(data[0])
        const startDate = data[0].start_date;
        const dueDate = data[0].due_date;
        const today = moment().toDate()
        // Hitung durasi (hari)
        const dayBehind = startDate ? moment(dueDate).diff(moment(today), "days") : 0;
        let weekBehind =  startDate ? moment(today).diff(moment(startDate), "days") : 0;
        weekBehind = Math.ceil(weekBehind / 7 );
        
        setDayBehind(dayBehind)
        setWeekBehind(weekBehind)
        setLoading(false)
        // eslint-disable-next-line
    },[data])

    if(isLoading){
        return(
            <Loading
                loading={isLoading}
            />
        )
    }

    return(
        <section className="">
            <section>
                <Card>
                    <Card.Body>
                        <div className="flex flex-row w-full">
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {dataProfile?.project_name}
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>START DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.start_date) ? moment(dataProfile.start_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>DUE DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.due_date) ? moment(dataProfile.due_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                
                    </Card.Body>
                </Card>
            </section>

            <section className="">
                <Card>
                    <Card.Body>
                        <TabSubTransaction activeTab={activeTab!} setActiveTab={setActiveTab} />
                        {activeTab === "bill" && <TabSubBill data_profile={dataProfile!} />}
                        {activeTab === "service_bill" && <TabSubServiceBill data_profile={dataProfile!} />}
                        {activeTab === "spend_money" && <TabSubSpendMoney data_profile={dataProfile!} />}
                        {activeTab === "received_money" && <TabSubReceivedMoney data_profile={dataProfile!} />}
                        {activeTab === "invoice" && <TabSubInvoice data_profile={dataProfile!} />}
                        {activeTab === "payment_bill_item" && <TabSubPaymentBillItem data_profile={dataProfile!} />}
                        {activeTab === "payment_bill_service" && <TabSubPaymentBillService data_profile={dataProfile!} />}
                        {activeTab === "payment_invoice" && <TabSubPaymentInvoice data_profile={dataProfile!} />}
                    </Card.Body>
                </Card>
            </section>

        </section>
    )

}

export function TabSubBill(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const [isLoading , setLoading] = useState(true)
    const {data , isLoading:loadingData, refetch} = useBillByProject(Number(props.data_profile?.project_id))
    const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    const api = useApi()


    const methods = useForm<FormBillType>({
        defaultValues: {
            bills: [],
        },
    });
    
    const [editField, setEditField] = useState<number | null>(null)
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null)
    const [deleteErrorMessage, setDeleteErrorMessage] = useState<string | null>(null)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const { handleSubmit, setValue, getValues } = methods;
    const { fields, remove } = useFieldArray({
        control: methods.control,
        name:'bills'
    })

    useEffect(() => {
        if (loadingData) {
            setLoading(true)
            return;
        } 
        setValue('bills',data)
        setLoading(false)
        // eslint-disable-next-line
    },[data])
    
    const onSubmit = async (value: FormBillType) => {
        const newData: FormBillBoqType[] = value.bills
            .filter(item => item.project_boq_id)
            .map((item) => ({
                project_id: item.project_id,
                trx_source: 1,
                trx_source_id: item.bill_detail_id,
                trx_date: item.transaction_date,
                trx_amount: Number(item.total) + Number(item.total_tax_paid),
                project_boq_id: item.project_boq_id,
                project_transaction_id: item.project_transaction_id
            }))

        if (newData.length === 0) return

        await toast.promise(api.post("/project/save_bill_mapping", newData), {
            loading: "Saving data...",
            success: (res) => res.data.message ?? "Data saved successfully",
            error: (err) =>
                err.response?.data?.detail?.message ??
                err.response?.data?.message ??
                "Failed to save data",
        })

        refetch()
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    };

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    const onDeleteRow = async () => {
        if (deleteIndex === null) return
        const row = getValues(`bills.${deleteIndex}`) as BillType
        const ptid = row?.project_transaction_id

        if (ptid == null || ptid === undefined) {
            remove(deleteIndex)
            setDeleteIndex(null)
            return
        }

        setDeleteLoading(true)
        try {
            await api.delete("/project/delete_project_trx_boq", {
                params: { project_transaction_id: ptid },
            })
            setDeleteIndex(null)
            await refetch()
        } catch (err) {
            setDeleteIndex(null)
            setDeleteErrorMessage(parseDeleteTrxError(err))
        } finally {
            setDeleteLoading(false)
        }
    }
   
    if(isLoading){
        return(
            <Loading
                loading={isLoading}
            />
        )
    }    

    const totalAmount = fields.reduce((sum, item) => sum + Number(item.total) + Number(item.total_tax_paid), 0);

    return(
        <section>

            <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="top-0 z-1 !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>BILL ID </th>
                            <th>DATE</th>
                            <th>VENDOR</th>
                            <th>DESCRIPTION</th>
                            <th>QTY</th>
                            <th>UNIT</th>
                            <th>PRICE</th>
                            <th>DISC</th>
                            <th>SUBTOTAL</th>
                            <th>TAX</th>
                            <th>AMOUNT</th>
                            <th>BOQ</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        fields.length === 0 ? (
                            <tr><td colSpan={14}>No Data Available</td></tr>
                        ):
                            
                        fields.map((arrField, key) => {
                            return (
                                    <Controller
                                        key={arrField.id}
                                        control={methods.control}
                                        name={`bills.${key}`}
                                        render={({ field }) => {
                                        if (editField === key) {
                                            return (
                                                <TableBillItem
                                                    dataProject={props.data_profile!}
                                                    key={arrField.id}
                                                    index={editField}
                                                    action="edit"
                                                    dropdownBoq={dropdownBoq}
                                                    isHideForm={false}
                                                    defaultValues={field.value}
                                                    onCancelEditing={() => setEditField(null)}
                                                    onSubmitData={(value) => {
                                                        field.onChange(value)
                                                        setEditField(null)
                                                    }}
                                                />
                                                
                                            )
                                        } else {
                                            return (
                                                <tr>
                                                    <td className="text-center">{key + 1}</td>
                                                    <td>{field.value.trx_code}</td>
                                                    <td>{moment(field.value.transaction_date).format('DD/MM/YYYY')}</td>
                                                    <td>{field.value.vendor_name}</td>
                                                    <td>{field.value.vendor_description}</td>
                                                    <td className="text-right">{convertNumber(field.value.quantity_bill).intoNormalAmount}</td>
                                                    <td>{field.value.unit_convention}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.price_bill)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.discount)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.total)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.total_tax_paid)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.total) + Number(field.value.total_tax_paid)).intoCurrency}</td>
                                                    <td>{field.value.boq_name}</td>
                                                    <td>
                                                    <section className="flex justify-center items-center">
                                                        {!isDisabledForm && (
                                                            <>
                                                                <ActionButton.Update
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(key)}
                                                                />
                                                                {field.value.project_transaction_id != null && (
                                                                    <ActionButton.Delete
                                                                        permission="AT021"
                                                                        onClick={() => setDeleteIndex(key)}
                                                                    />
                                                                )}
                                                            </>
                                                        )}
                                                        
                                                    </section>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        }}
                                    />
                            
                            )
                        })}
                    </tbody>
                </BaseTable>
            </div>

            <div className="mt-[30px]">
                <div className="flex justify-end w-full mt-4">
                    <div className="text-right font-bold ">Total Amount : {convertNumber(totalAmount).intoCurrency}</div>
                </div>
                <div className="flex justify-end ">
                    <Button color="primary" 
                        disabled={isDisabledForm}
                        className="min-w-[100px]"
                        type="button"
                        permission="ST19"
                        onClick={handleSubmit(onSubmit, onError)}
                    >
                        SAVE
                    </Button>
                </div>
            </div>

            <ProjectTrxDeleteModals
                showConfirm={deleteIndex !== null}
                onCloseConfirm={() => setDeleteIndex(null)}
                deleteLoading={deleteLoading}
                onConfirmDelete={onDeleteRow}
                errorMessage={deleteErrorMessage}
                onDismissError={() => setDeleteErrorMessage(null)}
            />
        </section>
    )
}

export function TabSubServiceBill(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const [isLoading , setLoading] = useState(true)
    const {data , isLoading:loadingData, refetch} = useBillServiceByProject(Number(props.data_profile?.project_id))
    const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    const api = useApi()


    const methods = useForm<FormBillServiceType>({
        defaultValues: {
            bills: [],
        },
    });
    
    const [editField, setEditField] = useState<number | null>(null)
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null)
    const [deleteErrorMessage, setDeleteErrorMessage] = useState<string | null>(null)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const { handleSubmit, setValue, getValues } = methods;
    const { fields, remove } = useFieldArray({
        control: methods.control,
        name:'bills'
    })

    useEffect(() => {
        if (loadingData) {
            setLoading(true)
            return;
        } 
        setValue('bills',data)
        setLoading(false)
        
        // eslint-disable-next-line
    },[data])
    
    const onSubmit = async (value: FormBillServiceType) => {
    
        const newData: FormBillBoqType[] = value.bills.map((item) => ({
            project_id: item.project_id,
            trx_source: 2, //untuk bill service = 2
            trx_source_id: item.bill_service_detail_id,
            trx_date: item.transaction_date,
            trx_amount: Number(item.total) + Number(item.total_tax_paid),
            project_boq_id: item.project_boq_id,
            project_transaction_id: item.project_transaction_id
        }));
    
        try {
            const errors: string[] = [];
        
            for (const [i, d] of newData.entries()) {
              try {
                await billTransactionSchema.validate(d);
              } catch (err: any) {
                errors.push(`Row ${i + 1}: ${err.message}`);
              }
            }
        

            if (errors.length > 0) {
              errors.forEach((msg) => toast.error(msg));
              return; 
            }else{
                await toast.promise(api.post("/project/save_bill_mapping", newData), {
                    loading: "Saving data...",
                    success: (res) => res.data.message ?? "Data saved successfully",
                    error: (err) =>
                        err.response?.data?.detail?.message ??
                        err.response?.data?.message ??
                        "Failed to save data",
                    });
            
                refetch();
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
        } 
        }
           
        catch (error: any) {
        
            if (error.name === "ValidationError") {
                toast.error(error.message || "Invalid data");
            } else {
                toast.error("An unexpected error occurred");
            }
        }
    };

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    const onDeleteRow = async () => {
        if (deleteIndex === null) return
        const row = getValues(`bills.${deleteIndex}`) as BillServiceType
        const ptid = row?.project_transaction_id

        if (ptid == null || ptid === undefined) {
            remove(deleteIndex)
            setDeleteIndex(null)
            return
        }

        setDeleteLoading(true)
        try {
            await api.delete("/project/delete_project_trx_boq", {
                params: { project_transaction_id: ptid },
            })
            setDeleteIndex(null)
            await refetch()
        } catch (err) {
            setDeleteIndex(null)
            setDeleteErrorMessage(parseDeleteTrxError(err))
        } finally {
            setDeleteLoading(false)
        }
    }
   
    if(isLoading){
        return(
            <Loading
                loading={isLoading}
            />
        )
    }    

    const totalAmount = fields.reduce((sum, item) => sum + Number(item.total) + Number(item.total_tax_paid), 0);

    return(
        <section>

            <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-[1] !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>BILL SERVICE ID </th>
                            <th>DATE</th>
                            <th>VENDOR</th>
                            <th>DESCRIPTION</th>
                            <th>QTY</th>
                            <th>UNIT</th>
                            <th>PRICE</th>
                            <th>DISC</th>
                            <th>SUBTOTAL</th>
                            <th>TAX</th>
                            <th>AMOUNT</th>
                            <th>BOQ</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        fields.length === 0 ? (
                            <tr><td colSpan={14}>No Data Available</td></tr>
                        ):
                            
                        fields.map((arrField, key) => {
                            return (
                                    <Controller
                                        key={arrField.id}
                                        control={methods.control}
                                        name={`bills.${key}`}
                                        render={({ field }) => {
                                        if (editField === key) {
                                            return (
                                                <TableBillServiceItem
                                                    dataProject={props.data_profile!}
                                                    key={arrField.id}
                                                    index={editField}
                                                    action="edit"
                                                    dropdownBoq={dropdownBoq}
                                                    isHideForm={false}
                                                    defaultValues={field.value}
                                                    onCancelEditing={() => setEditField(null)}
                                                    onSubmitData={(value) => {
                                                        field.onChange(value)
                                                        setEditField(null)
                                                    }}
                                                />
                                                
                                            )
                                        } else {
                                            return (
                                                <tr>
                                                    <td className="text-center">{key + 1}</td>
                                                    <td>{field.value.trx_code}</td>
                                                    <td>{moment(field.value.transaction_date).format('DD/MM/YYYY')}</td>
                                                    <td>{field.value.vendor_name}</td>
                                                    <td>{`${field.value.coa_code} - ${field.value.coa_name} | ${field.value.description}`}</td>
                                                    <td className="text-right">{convertNumber(field.value.quantity_order).intoNormalAmount}</td>
                                                    <td>{field.value.mr_unit_name}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.price_bill)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.discount)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.total)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.total_tax_paid)).intoCurrency}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.total) + Number(field.value.total_tax_paid)).intoCurrency}</td>
                                                    <td>{field.value.boq_name}</td>
                                                    <td>
                                                    <section className="flex justify-center items-center">
                                                        {!isDisabledForm && (
                                                            <>
                                                                <ActionButton.Update
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(key)}
                                                                />
                                                                {field.value.project_transaction_id != null && (
                                                                    <ActionButton.Delete
                                                                        permission="AT021"
                                                                        onClick={() => setDeleteIndex(key)}
                                                                    />
                                                                )}
                                                            </>
                                                        )}
                                                        
                                                    </section>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        }}
                                    />
                            
                            )
                        })}
                    </tbody>
                </BaseTable>
                <div className="flex justify-end w-full mt-4">
                    <div className="text-right font-bold ">Total Amount : {convertNumber(totalAmount).intoCurrency}</div>
                </div>
            </div>

            <div className="flex justify-end mt-[30px] mb-[30px]">
                <Button color="primary" 
                    disabled={isDisabledForm}
                    className="min-w-[100px]"
                    type="button"
                    permission="ST19"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    SAVE
                </Button>
            </div>

            <ProjectTrxDeleteModals
                showConfirm={deleteIndex !== null}
                onCloseConfirm={() => setDeleteIndex(null)}
                deleteLoading={deleteLoading}
                onConfirmDelete={onDeleteRow}
                errorMessage={deleteErrorMessage}
                onDismissError={() => setDeleteErrorMessage(null)}
            />
        </section>
    )
}

export function TabSubSpendMoney(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const [isLoading , setLoading] = useState(true)
    const {data , isLoading:loadingData, refetch} = useSpendMoneyByProject(Number(props.data_profile?.project_id))
    const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    const api = useApi()


    const methods = useForm<FormSpendMoneyType>({
        defaultValues: {
            bills: [],
        },
    });
    
    const [editField, setEditField] = useState<number | null>(null)
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null)
    const [deleteErrorMessage, setDeleteErrorMessage] = useState<string | null>(null)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const { handleSubmit, setValue, getValues } = methods;
    const { fields, remove } = useFieldArray({
        control: methods.control,
        name:'bills'
    })

    useEffect(() => {
        if (loadingData) {
            setLoading(true)
            return;
        } 
        setValue('bills',data)
        setLoading(false)
        
        // eslint-disable-next-line
    },[data])
    
    const onSubmit = async (value: FormSpendMoneyType) => {
        const newData: FormBillBoqType[] = value.bills
            .filter(item => item.project_boq_id)
            .map((item) => ({
                project_id: item.project_id,
                trx_source: 3,
                trx_source_id: item.finance_detail_id,
                trx_date: item.transaction_date,
                trx_amount: Number(item.amount),
                project_boq_id: item.project_boq_id,
                project_transaction_id: item.project_transaction_id
            }))

        if (newData.length === 0) return

        await toast.promise(api.post("/project/save_bill_mapping", newData), {
            loading: "Saving data...",
            success: (res) => res.data.message ?? "Data saved successfully",
            error: (err) =>
                err.response?.data?.detail?.message ??
                err.response?.data?.message ??
                "Failed to save data",
        })

        refetch()
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    };

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    const onDeleteRow = async () => {
        if (deleteIndex === null) return
        const row = getValues(`bills.${deleteIndex}`) as SpendMoneyType
        const ptid = row?.project_transaction_id

        if (ptid == null || ptid === undefined) {
            remove(deleteIndex)
            setDeleteIndex(null)
            return
        }

        setDeleteLoading(true)
        try {
            await api.delete("/project/delete_project_trx_boq", {
                params: { project_transaction_id: ptid },
            })
            setDeleteIndex(null)
            await refetch()
        } catch (err) {
            setDeleteIndex(null)
            setDeleteErrorMessage(parseDeleteTrxError(err))
        } finally {
            setDeleteLoading(false)
        }
    }
   
    if(isLoading){
        return(
            <Loading
                loading={isLoading}
            />
        )
    }    

    const totalAmount = fields.reduce((sum, item) => sum + Number(item.amount), 0);

    return(
        <section>

            <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-[1] !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>FINANCE ID </th>
                            <th>DATE</th>
                            <th>GROUP</th>
                            <th>TRADER NAME</th>
                            <th>ACCOUNT</th>
                            <th>DESCRIPTION</th>
                            <th>AMOUNT</th>
                            <th>BOQ</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        fields.length === 0 ? (
                            <tr><td colSpan={14}>No Data Available</td></tr>
                        ):
                            
                        fields.map((arrField, key) => {
                            return (
                                    <Controller
                                        key={arrField.id}
                                        control={methods.control}
                                        name={`bills.${key}`}
                                        render={({ field }) => {
                                        if (editField === key) {
                                            return (
                                                <TableSpendMoneyItem
                                                    dataProject={props.data_profile!}
                                                    key={arrField.id}
                                                    index={editField}
                                                    action="edit"
                                                    dropdownBoq={dropdownBoq}
                                                    isHideForm={false}
                                                    defaultValues={field.value}
                                                    onCancelEditing={() => setEditField(null)}
                                                    onSubmitData={(value) => {
                                                        field.onChange(value)
                                                        setEditField(null)
                                                    }}
                                                />
                                                
                                            )
                                        } else {
                                            return (
                                                <tr>
                                                    <td className="text-center">{key + 1}</td>
                                                    <td>{field.value.trx_code}</td>
                                                    <td>{moment(field.value.transaction_date).format('DD/MM/YYYY')}</td>
                                                    <td>{field.value.group}</td>
                                                    <td>{field.value.trade_name}</td>
                                                    <td>{`${field.value.coa_code} - ${field.value.coa_name}`}</td>
                                                    <td>{field.value.memo}</td>
                                                    <td className="text-right">{convertNumber(Number(field.value.amount)).intoCurrency}</td>
                                                    <td>{field.value.boq_name}</td>
                                                    <td>
                                                    <section className="flex justify-center items-center">
                                                        {!isDisabledForm && (
                                                            <>
                                                                <ActionButton.Update
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(key)}
                                                                />
                                                                {field.value.project_transaction_id != null && (
                                                                    <ActionButton.Delete
                                                                        permission="AT021"
                                                                        onClick={() => setDeleteIndex(key)}
                                                                    />
                                                                )}
                                                            </>
                                                        )}
                                                        
                                                    </section>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        }}
                                    />
                            
                            )
                        })}
                    </tbody>
                </BaseTable>
                <div className="flex justify-end w-full mt-4">
                    <div className="text-right font-bold ">Total Amount : {convertNumber(totalAmount).intoCurrency}</div>
                </div>
            </div>

            <div className="flex justify-end mt-[30px] mb-[30px]">
                <Button color="primary" 
                    disabled={isDisabledForm}
                    className="min-w-[100px]"
                    type="button"
                    permission="ST19"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    SAVE
                </Button>
            </div>

            <ProjectTrxDeleteModals
                showConfirm={deleteIndex !== null}
                onCloseConfirm={() => setDeleteIndex(null)}
                deleteLoading={deleteLoading}
                onConfirmDelete={onDeleteRow}
                errorMessage={deleteErrorMessage}
                onDismissError={() => setDeleteErrorMessage(null)}
            />
        </section>
    )
}

export function TabSubReceivedMoney(props:TabProps): JSX.Element {
    // const [isLoading , setLoading] = useState(true)
    const {data , isLoading:loadingData} = useReceivedMoneyByProject(Number(props.data_profile?.project_id))
    const totalAmount = data.reduce((sum, item) => sum + Number(item.amount), 0);
    // const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    
   
    if(loadingData){
        return(
            <Loading
                loading={loadingData}
            />
        )
    }    

    return(
        <section>

            <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-[1] !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>FINANCE ID </th>
                            <th>DATE</th>
                            <th>GROUP</th>
                            <th>TRADER NAME</th>
                            <th>ACCOUNT</th>
                            <th>DESCRIPTION</th>
                            <th>AMOUNT</th>
                            {/* <th>ACTION</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.length === 0 ? (
                                <tr><td colSpan={14}>No Data Available</td></tr>
                            ):
                                
                            data.map((item, key) => {
                                return (
                                        
                                    <tr>
                                        <td className="text-center">{key + 1}</td>
                                        <td>{item.trx_code}</td>
                                        <td>{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
                                        <td>{item.group}</td>
                                        <td>{item.trade_name}</td>
                                        <td>{`${item.coa_code} - ${item.coa_name}`}</td>
                                        <td>{item.memo}</td>
                                        <td className="text-right">{convertNumber(Number(item.amount)).intoCurrency}</td>
                                        {/* <td>
                                            <section className="flex justify-center items-center">
                                                {!isDisabledForm && (
                                                    <>
                                                        <ActionButton.Update
                                                            permission="AT021"
                                                            onClick={() => setEditField(key)}
                                                        />
                                                    </>
                                                )}
                                                
                                            </section> 
                                        </td> */}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </BaseTable>
                <div className="flex justify-end w-full mt-4">
                    <div className="text-right font-bold ">Total Amount : {convertNumber(totalAmount).intoCurrency}</div>
                </div>
            </div>
        </section>
    )
}

export function TabSubInvoice(props:TabProps): JSX.Element {
    // const [isLoading , setLoading] = useState(true)
    const {data , isLoading:loadingData} = useInvoiceByProject(Number(props.data_profile?.project_id))
    const totalAmount = data.reduce((sum, item) => sum + Number(item.amount), 0);
    // const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    
   
    if(loadingData){
        return(
            <Loading
                loading={loadingData}
            />
        )
    }    

    return(
        <section>

            <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-[1] !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>INVOICE ID </th>
                            <th>DATE</th>
                            <th>CUSTOMER</th>
                            <th>DESCRIPTION</th>
                            <th>QTY</th>
                            <th>UNIT</th>
                            <th>PRICE</th>
                            <th>DISC</th>
                            <th>SUB TOTAL</th>
                            <th>TAX</th>
                            <th>AMOUNT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.length === 0 ? (
                                <tr><td colSpan={12}>No Data Available</td></tr>
                            ):
                                
                            data.map((item, key) => {
                                return (
                                        
                                    <tr>
                                        <td className="text-center">{key + 1}</td>
                                        <td>{item.trx_code}</td>
                                        <td>{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
                                        <td>{item.customer_name}</td>
                                        <td>{item.description}</td>
                                        <td className="text-right">{convertNumber(Number(item.quantity_invoice)).intoNormalAmount}</td>
                                        <td>{item.unit}</td>
                                        <td className="text-right">{convertNumber(Number(item.price_invoice)).intoCurrency}</td>
                                        <td className="text-right">{convertNumber(Number(item.discount)).intoNormalAmount} %</td>
                                        <td className="text-right">{convertNumber(Number(item.total)).intoCurrency}</td>
                                        <td className="text-right">{convertNumber(Number(item.total_tax_collect)).intoCurrency}</td>
                                        <td className="text-right">{convertNumber(Number(item.amount)).intoCurrency}</td>
                                        {/* <td>
                                            <section className="flex justify-center items-center">
                                                {!isDisabledForm && (
                                                    <>
                                                        <ActionButton.Update
                                                            permission="AT021"
                                                            onClick={() => setEditField(key)}
                                                        />
                                                    </>
                                                )}
                                                
                                            </section> 
                                        </td> */}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </BaseTable>
                <div className="flex justify-end w-full mt-4">
                    <div className="text-right font-bold ">Total Amount : {convertNumber(totalAmount).intoCurrency}</div>
                </div>
            </div>
        </section>
    )
}

export function TabSubPaymentBillItem(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const [isLoading, setLoading] = useState(true)
    const {data, isLoading:loadingData, refetch} = usePaymentBillByProject(Number(props.data_profile?.project_id), "item")
    const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    const api = useApi()
    const [editField, setEditField] = useState<number | null>(null)
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null)
    const [deleteErrorMessage, setDeleteErrorMessage] = useState<string | null>(null)
    const [deleteLoading, setDeleteLoading] = useState(false)

    const methods = useForm<{payments: PaymentBillItem[]}>({
        defaultValues: { payments: [] }
    })
    const { handleSubmit, setValue, getValues } = methods
    const { fields, remove } = useFieldArray({
        control: methods.control,
        name: 'payments'
    })

    useEffect(() => {
        if (loadingData) {
            setLoading(true)
            return
        }
        setValue('payments', data)
        setLoading(false)
        // eslint-disable-next-line
    }, [data])

    const onSubmit = async (value: {payments: PaymentBillItem[]}) => {
        const newData: FormBillBoqType[] = value.payments
            .filter(item => item.project_boq_id)
            .map((item) => ({
                project_id: Number(props.data_profile?.project_id),
                trx_source: 6,
                trx_source_id: item.payment_bill_id,
                trx_date: item.transaction_date,
                trx_amount: Number(item.deposit_amount) + Number(item.payment_amount),
                project_boq_id: item.project_boq_id!,
                project_transaction_id: item.project_transaction_id
            }))

        if (newData.length === 0) return

        await toast.promise(api.post("/project/save_bill_mapping", newData), {
            loading: "Saving data...",
            success: (res) => res.data.message ?? "Data saved successfully",
            error: (err) =>
                err.response?.data?.detail?.message ??
                err.response?.data?.message ??
                "Failed to save data",
        })

        refetch()
        setEditField(null)
    }

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    }

    const onDeleteRow = async () => {
        if (deleteIndex === null) return
        const row = getValues(`payments.${deleteIndex}`) as PaymentBillItem
        const ptid = row?.project_transaction_id

        if (ptid == null || ptid === undefined) {
            remove(deleteIndex)
            setDeleteIndex(null)
            return
        }

        setDeleteLoading(true)
        try {
            await api.delete("/project/delete_project_trx_boq", {
                params: { project_transaction_id: ptid },
            })
            setDeleteIndex(null)
            await refetch()
        } catch (err) {
            setDeleteIndex(null)
            setDeleteErrorMessage(parseDeleteTrxError(err))
        } finally {
            setDeleteLoading(false)
        }
    }

    if (isLoading) {
        return <Loading loading={isLoading} />
    }

    const totalAmount = fields.reduce((sum, item) => sum + Number(item.deposit_amount) + Number(item.payment_amount), 0)

    return (
        <section>
            <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-1 !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>PAYMENT ID</th>
                            <th>DATE</th>
                            <th>REF BILL ID</th>
                            <th>TYPE</th>
                            <th>DESCRIPTION</th>
                            <th>DEPOSIT</th>
                            <th>PAYMENT</th>
                            <th>TOTAL PAYMENT</th>
                            <th>BOQ</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.length === 0 ? (
                            <tr><td colSpan={11}>No Data Available</td></tr>
                        ) : (
                            fields.map((arrField, key) => (
                                <Controller
                                    key={arrField.id}
                                    control={methods.control}
                                    name={`payments.${key}`}
                                    render={({ field }) => (
                                        <tr>
                                            <td className="text-center">{key + 1}</td>
                                            <td>{field.value.trx_code}</td>
                                            <td>{moment(field.value.transaction_date).format('DD/MM/YYYY')}</td>
                                            <td>{field.value.ref_bill_id}</td>
                                            <td>{field.value.source_type === 1 ? "BILL ITEM" : "BILL SERVICE"}</td>
                                            <td>{field.value.description}</td>
                                            <td className="text-right">{convertNumber(Number(field.value.deposit_amount)).intoCurrency}</td>
                                            <td className="text-right">{convertNumber(Number(field.value.payment_amount)).intoCurrency}</td>
                                            <td className="text-right">{convertNumber(Number(field.value.deposit_amount) + Number(field.value.payment_amount)).intoCurrency}</td>
                                            <td className="min-w-[150px]">
                                                {editField === key ? (
                                                    <Select
                                                        placeholder="Select BOQ"
                                                        options={dropdownBoq}
                                                        value={
                                                            field.value.project_boq_id
                                                                ? dropdownBoq.find(b => Number(b.value) === field.value.project_boq_id) ?? null
                                                                : null
                                                        }
                                                        onChange={(e) => field.onChange({
                                                            ...field.value,
                                                            project_boq_id: e ? Number(e.value) : null,
                                                            boq_name: e?.label ?? null,
                                                        })}
                                                    />
                                                ) : (
                                                    field.value.boq_name ?? ""
                                                )}
                                            </td>
                                            <td>
                                                <section className="flex justify-center items-center gap-1">
                                                    {!isDisabledForm && (
                                                        editField === key ? (
                                                            <>
                                                                <ActionButton.Close
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(null)}
                                                                />
                                                                <ActionButton.Add
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(null)}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <ActionButton.Update
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(key)}
                                                                />
                                                                {field.value.project_transaction_id != null && (
                                                                    <ActionButton.Delete
                                                                        permission="AT021"
                                                                        onClick={() => setDeleteIndex(key)}
                                                                    />
                                                                )}
                                                            </>
                                                        )
                                                    )}
                                                </section>
                                            </td>
                                        </tr>
                                    )}
                                />
                            ))
                        )}
                    </tbody>
                </BaseTable>
            </div>
            <div className="flex justify-between items-center mt-4 mb-4">
                <div className="font-bold">Total Payment : {convertNumber(totalAmount).intoCurrency}</div>
                <Button
                    color="primary"
                    disabled={isDisabledForm}
                    className="min-w-[100px]"
                    type="button"
                    permission="ST19"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    SAVE
                </Button>
            </div>

            <ProjectTrxDeleteModals
                showConfirm={deleteIndex !== null}
                onCloseConfirm={() => setDeleteIndex(null)}
                deleteLoading={deleteLoading}
                onConfirmDelete={onDeleteRow}
                errorMessage={deleteErrorMessage}
                onDismissError={() => setDeleteErrorMessage(null)}
            />
        </section>
    )
}

export function TabSubPaymentBillService(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const [isLoading, setLoading] = useState(true)
    const {data, isLoading:loadingData, refetch} = usePaymentBillByProject(Number(props.data_profile?.project_id), "service")
    const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    const api = useApi()
    const [editField, setEditField] = useState<number | null>(null)
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null)
    const [deleteErrorMessage, setDeleteErrorMessage] = useState<string | null>(null)
    const [deleteLoading, setDeleteLoading] = useState(false)

    const methods = useForm<{payments: PaymentBillItem[]}>({
        defaultValues: { payments: [] }
    })
    const { handleSubmit, setValue, getValues } = methods
    const { fields, remove } = useFieldArray({
        control: methods.control,
        name: 'payments'
    })

    useEffect(() => {
        if (loadingData) {
            setLoading(true)
            return
        }
        setValue('payments', data)
        setLoading(false)
        // eslint-disable-next-line
    }, [data])

    const onSubmit = async (value: {payments: PaymentBillItem[]}) => {
        const newData: FormBillBoqType[] = value.payments
            .filter(item => item.project_boq_id)
            .map((item) => ({
                project_id: Number(props.data_profile?.project_id),
                trx_source: 7,
                trx_source_id: item.payment_bill_id,
                trx_date: item.transaction_date,
                trx_amount: Number(item.deposit_amount) + Number(item.payment_amount),
                project_boq_id: item.project_boq_id!,
                project_transaction_id: item.project_transaction_id
            }))

        if (newData.length === 0) return

        await toast.promise(api.post("/project/save_bill_mapping", newData), {
            loading: "Saving data...",
            success: (res) => res.data.message ?? "Data saved successfully",
            error: (err) =>
                err.response?.data?.detail?.message ??
                err.response?.data?.message ??
                "Failed to save data",
        })

        refetch()
        setEditField(null)
    }

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    }

    const onDeleteRow = async () => {
        if (deleteIndex === null) return
        const row = getValues(`payments.${deleteIndex}`) as PaymentBillItem
        const ptid = row?.project_transaction_id

        if (ptid == null || ptid === undefined) {
            remove(deleteIndex)
            setDeleteIndex(null)
            return
        }

        setDeleteLoading(true)
        try {
            await api.delete("/project/delete_project_trx_boq", {
                params: { project_transaction_id: ptid },
            })
            setDeleteIndex(null)
            await refetch()
        } catch (err) {
            setDeleteIndex(null)
            setDeleteErrorMessage(parseDeleteTrxError(err))
        } finally {
            setDeleteLoading(false)
        }
    }

    if (isLoading) {
        return <Loading loading={isLoading} />
    }

    const totalAmount = fields.reduce((sum, item) => sum + Number(item.deposit_amount) + Number(item.payment_amount), 0)

    return (
        <section>
            <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-1 !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>PAYMENT ID</th>
                            <th>DATE</th>
                            <th>REF SERVICE ID</th>
                            <th>TYPE</th>
                            <th>DESCRIPTION</th>
                            <th>DEPOSIT</th>
                            <th>PAYMENT</th>
                            <th>TOTAL PAYMENT</th>
                            <th>BOQ</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.length === 0 ? (
                            <tr><td colSpan={11}>No Data Available</td></tr>
                        ) : (
                            fields.map((arrField, key) => (
                                <Controller
                                    key={arrField.id}
                                    control={methods.control}
                                    name={`payments.${key}`}
                                    render={({ field }) => (
                                        <tr>
                                            <td className="text-center">{key + 1}</td>
                                            <td>{field.value.trx_code}</td>
                                            <td>{moment(field.value.transaction_date).format('DD/MM/YYYY')}</td>
                                            <td>{field.value.ref_bill_id}</td>
                                            <td>{field.value.source_type === 1 ? "BILL ITEM" : "BILL SERVICE"}</td>
                                            <td>{field.value.description}</td>
                                            <td className="text-right">{convertNumber(Number(field.value.deposit_amount)).intoCurrency}</td>
                                            <td className="text-right">{convertNumber(Number(field.value.payment_amount)).intoCurrency}</td>
                                            <td className="text-right">{convertNumber(Number(field.value.deposit_amount) + Number(field.value.payment_amount)).intoCurrency}</td>
                                            <td className="min-w-[150px]">
                                                {editField === key ? (
                                                    <Select
                                                        placeholder="Select BOQ"
                                                        options={dropdownBoq}
                                                        value={
                                                            field.value.project_boq_id
                                                                ? dropdownBoq.find(b => Number(b.value) === field.value.project_boq_id) ?? null
                                                                : null
                                                        }
                                                        onChange={(e) => field.onChange({
                                                            ...field.value,
                                                            project_boq_id: e ? Number(e.value) : null,
                                                            boq_name: e?.label ?? null,
                                                        })}
                                                    />
                                                ) : (
                                                    field.value.boq_name ?? ""
                                                )}
                                            </td>
                                            <td>
                                                <section className="flex justify-center items-center gap-1">
                                                    {!isDisabledForm && (
                                                        editField === key ? (
                                                            <>
                                                                <ActionButton.Close
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(null)}
                                                                />
                                                                <ActionButton.Add
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(null)}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <ActionButton.Update
                                                                    permission="AT021"
                                                                    onClick={() => setEditField(key)}
                                                                />
                                                                {field.value.project_transaction_id != null && (
                                                                    <ActionButton.Delete
                                                                        permission="AT021"
                                                                        onClick={() => setDeleteIndex(key)}
                                                                    />
                                                                )}
                                                            </>
                                                        )
                                                    )}
                                                </section>
                                            </td>
                                        </tr>
                                    )}
                                />
                            ))
                        )}
                    </tbody>
                </BaseTable>
            </div>
            <div className="flex justify-between items-center mt-4 mb-4">
                <div className="font-bold">Total Payment : {convertNumber(totalAmount).intoCurrency}</div>
                <Button
                    color="primary"
                    disabled={isDisabledForm}
                    className="min-w-[100px]"
                    type="button"
                    permission="ST19"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    SAVE
                </Button>
            </div>

            <ProjectTrxDeleteModals
                showConfirm={deleteIndex !== null}
                onCloseConfirm={() => setDeleteIndex(null)}
                deleteLoading={deleteLoading}
                onConfirmDelete={onDeleteRow}
                errorMessage={deleteErrorMessage}
                onDismissError={() => setDeleteErrorMessage(null)}
            />
        </section>
    )
}

export function TabSubPaymentInvoice(props:TabProps): JSX.Element {
    // const [isLoading , setLoading] = useState(true)
    const {data , isLoading:loadingData} = usePaymentInvoiceByProject(Number(props.data_profile?.project_id))
    const totalAmount = data.reduce((sum, item) => sum + Number(item.deposit_amount) + Number(item.payment_amount), 0);
    // const {dropdownBoq} = useBoqDetail(String(props.data_profile?.project_id!))
    
   
    if(loadingData){
        return(
            <Loading
                loading={loadingData}
            />
        )
    }    

    return(
        <section>

            <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-600px)]">
                <BaseTable>
                    <thead className="sticky top-0 z-[1] !bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>PAYMENT ID </th>
                            <th>DATE</th>
                            <th>REF INVOICE ID</th>
                            <th>DESCRIPTION</th>
                            <th>DEPOSIT</th>
                            <th>PAYMENT</th>
                            <th>TOTAL PAYMENT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.length === 0 ? (
                                <tr><td colSpan={14}>No Data Available</td></tr>
                            ):
                                
                            data.map((item, key) => {
                                return (
                                        
                                    <tr>
                                        <td className="text-center">{key + 1}</td>
                                        <td>{item.trx_code}</td>
                                        <td>{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
                                        <td>{item.ref_invoice_id}</td>
                                        <td>{item.description}</td>
                                        <td className="text-right">{convertNumber(Number(item.deposit_amount)).intoCurrency}</td>
                                        <td className="text-right">{convertNumber(Number(item.payment_amount)).intoCurrency}</td>
                                        <td className="text-right">{convertNumber(Number(item.deposit_amount) + Number(item.payment_amount)).intoCurrency}</td>
                                        {/* <td>
                                            <section className="flex justify-center items-center">
                                                {!isDisabledForm && (
                                                    <>
                                                        <ActionButton.Update
                                                            permission="AT021"
                                                            onClick={() => setEditField(key)}
                                                        />
                                                    </>
                                                )}
                                                
                                            </section> 
                                        </td> */}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </BaseTable>
                <div className="flex justify-end w-full mt-4">
                    <div className="text-right font-bold ">Total Payment : {convertNumber(totalAmount).intoCurrency}</div>
                </div>
            </div>
        </section>
    )
}